import request from 'utils/request'

const refreshToken = (options = {}) => request('auth/refresh/', { method: 'POST', ...options })
const login = (options = {}) => request('auth/login/', { method: 'POST', ...options })
const getMe = (options = {}) => request('auth/me/', { ...options })
const updateMe = (options = {}) => request('auth/me/', { method: 'POST', ...options })
const register = (options = {}) => request('auth/register/', { method: 'POST', ...options })
const changePassword = (options = {}) =>
  request('auth/password/change/', { method: 'POST', ...options })
const facebookAuth = (options = {}) => request('auth/facebook/', { method: 'POST', ...options })
const resetPassword = (options = {}) =>
  request('auth/password/reset/', { method: 'POST', ...options })
const verifyEmail = (options = {}) => request('auth/email/verify/', { method: 'POST', ...options })
const forgotPassword = (options = {}) =>
  request('auth/password/send-reset-email/', { method: 'POST', ...options })

export {
  login,
  register,
  verifyEmail,
  forgotPassword,
  facebookAuth,
  resetPassword,
  updateMe,
  getMe,
  changePassword,
  refreshToken,
}
